import { putMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const ASSIGN_SPECIALIST_LIST = 'ASSIGN_SPECIALIST_LIST';
export const ASSIGN_SPECIALIST_LIST_SUCCESS = 'ASSIGN_SPECIALIST_LIST_SUCCESS';
export const ASSIGN_SPECIALIST_LIST_FAILURE = 'ASSIGN_SPECIALIST_LIST_FAILURE';

// Action Creators
export const fetchAssignSpecialistList = () => ({
  type: ASSIGN_SPECIALIST_LIST,
});

export const fetchAssignSpecialistListSuccess = (data) => ({
  type: ASSIGN_SPECIALIST_LIST_SUCCESS,
  payload: data,
});

export const fetchAssignSpecialistListFailure = (error) => ({
  type: ASSIGN_SPECIALIST_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const assignSpecialistProviderCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchAssignSpecialistList(data, external));
    try {
      const response = await putMethodWithToken(
        external?.reassign ? url.reAssignSpecialist : url.assignSpecialist,
        data
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchAssignSpecialistListSuccess(response.data));
        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchAssignSpecialistListFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchAssignSpecialistListFailure(error.message));
    }
  };
};
